import { CopyHelper } from 'global/utils/CopyHelper';
import { makeAutoObservable } from 'mobx';
import { INITIAL_GROUP_OBJECT } from 'store/domain/groupStore';
import { RootStore } from 'store/rootStore';
import { EnrollmentPeriod, EnrollmentStage } from 'types/enrollmentService';
import { Group } from 'types/groupService';

export class GroupSidebarStore {
  rootStore: RootStore;
  group: Group = { ...INITIAL_GROUP_OBJECT };
  showToast = false;
  toastMessage = '';

  public setErrorToastStatus(status: boolean, message = ''): void {
    this.toastMessage = message;
    this.showToast = status;
  }

  getGroupLocally(group: Group): void {
    this.group = CopyHelper.deepCopy(group);
  }

  get activeEnrollmentPeriods(): EnrollmentPeriod[] {
    return this.rootStore.enrollmentStore.enrollmentPeriodsByGroupId
      .filter((enrollmentPeriod) => enrollmentPeriod.hasConfirmedProposal)
      .filter((enrollmentPeriod) => enrollmentPeriod.stage !== EnrollmentStage.SUBMITTED);
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
